<div class="wrapper-price">
    <span [ngClass]="{ 'wrapper-price__disable': disable }">
        <span [ngClass]="{ 'wrapper-price__pricing--hover': isHover }">
            <span class="wrapper-price__pricing">{{ pricingFormat }}</span>
        </span>
        <div class="wrapper-price__currency">
            <span
                [ngClass]="{
                'wrapper-price__currency--hover': isHover,
                'wrapper-price__currency__disable': disable}">
                {{ convertedPricing.currency }}
            </span>
        </div>
    </span>
</div>
